import PropTypes from 'prop-types';
import { EdmundsAPI } from 'client/data/api/api-client';
import { withMetrics } from 'client/data/api/api-metrics';
import { createModelSegment } from 'client/data/luckdragon/segment';
import { VisitorModel } from './visitor';
import { buildPopularStylesPath, VehicleModel } from './vehicle-v2';

const Tco = PropTypes.shape({
  insurance: PropTypes.number,
  maintenance: PropTypes.number,
  repairs: PropTypes.number,
  taxesAndFees: PropTypes.number,
  financeInterest: PropTypes.number,
  depreciation: PropTypes.number,
  fuel: PropTypes.number,
  tcoPrice: PropTypes.number,
  averageCostPerMile: PropTypes.number,
});

const TcoYears = PropTypes.shape({
  '1': Tco,
  '2': Tco,
  '3': Tco,
  '4': Tco,
  '5': Tco,
});

const StyleTco = PropTypes.shape({
  totalCash: PropTypes.number,
  total: Tco,
  years: TcoYears,
});

const Style = PropTypes.shape({
  styleId: PropTypes.number,
  styleName: PropTypes.string,
  tco: StyleTco,
});

const Styles = PropTypes.arrayOf(Style);

export const TcoEntities = {
  Styles,
  Style,
  StyleTco,
  TcoYears,
  Tco,
};

export function buildTcoPath({ make, model, year }) {
  return `makes["${make}"].models["${model}"].years["${year}"].tco.styles`;
}

export const CostToOwnModel = createModelSegment('costToOwn', [
  /**
   * Resolves tco data for all styles of given MMY
   * @see buildTcoPath
   * @returns Object<StyleTco>
   */
  {
    path: 'makes["{make}"].models["{model}"].years["{year}"].tco.styles',
    async resolve({ make, model, year }, context) {
      const [{ zipCode }, styleIds] = await Promise.all([
        context.resolveValue('location', VisitorModel),
        context
          .resolveValue(buildPopularStylesPath({ make, model, year }), VehicleModel)
          .then(styles => (styles ? styles.map(({ id }) => id) : [])),
      ]);

      if (!styleIds?.length) {
        return Promise.resolve({});
      }

      return withMetrics(EdmundsAPI, context)
        .fetchJson(`/tco/v3?zip=${zipCode}&styleIds=${styleIds.join(',')}`)
        .then(({ results }) => results)
        .catch(() => ({}));
    },
  },
]);
